import { useBinanceSocket, Trade } from "../../hooks/useBinanceDeepth"

type Props = { pair: string }

const RecentTrades = ({ pair }: Props) => {
  const trades = useBinanceSocket(pair, "trade") as Trade[]

  return (
    <div className="recent-trades">
      <div className="trade-list">
        <table>
          <thead>
            <tr>
              <th>Price (USDT)</th>
              <th>Amount</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
        {trades.map((trade, i) => (
           <tr key={i}
            className={`trade ${trade.isBuyerMaker ? "sell" : "buy"}`}>
            <td>{parseFloat(trade.price).toFixed(4)}</td>
            <td>{parseFloat(trade.qty).toFixed(4)}</td>
            <td className="time">
              {new Date(trade.time).toLocaleTimeString([], { hour12: false })}

            </td>
          </tr>
        ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

         
        
export default RecentTrades
